import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import './index.css';
const root = createRoot(document.getElementById('root')!);
root.render(<React.StrictMode data-id="element-247">
    <HelmetProvider data-id="element-248">
      <App data-id="element-249" />
    </HelmetProvider>
  </React.StrictMode>);